<template>
  <div>
    <q-form
      :ref="formStructure.key"
      class="waybill-form"
      :model="model"
      :rules="modelRules"
      label-width="120px"
    >
      <q-form-item
        label="تاریخ شروع"
        prop="startDate"
      >
        <persian-date-picker
          v-model="startDate"
          :editable="true"
        />
      </q-form-item>

      <q-form-item
        label="تاریخ پایان"
        prop="endDate"
      >
        <persian-date-picker
          v-model="endDate"
          :editable="true"
        />
      </q-form-item>

      <q-form-item>
        <q-button
          type="primary"
          @click="print()"
        >
          <span>Print</span>
        </q-button>
      </q-form-item>
    </q-form>
  </div>
</template>

<script>
import reportMixin from "../../../models/reportMixin";

export default {
  name: "QPaymentAccountBalanceReport",

  mixins: [reportMixin],
  props: {
    formStructure: {required: true, type: Object}
  },
  data() {
    return {
      startDate:'',
      endDate: '',
      deliveryDate: '',
      model: {
        startDate: undefined,
        endDate: undefined,
        deliveryDate: undefined,
        status: 'delivered',
        truck: undefined,
        route: undefined,
      },
      modelRules: {}
    };
  },
  computed: {},
  watch:{
    startDate(){
      this.model.startDate =
              this.$tools.moment(this.startDate, 'jYYYY/jM/jD HH:mm:ss').format('YYYY/M/D HH:mm:ss');
    },
    endDate(){
      this.model.endDate =
              this.$tools.moment(this.endDate, 'jYYYY/jM/jD HH:mm:ss').format('YYYY/M/D HH:mm:ss');
    },
    deliveryDate(){
      this.model.deliveryDate =
              this.$tools.moment(this.deliveryDate, 'jYYYY/jM/jD HH:mm:ss').format('YYYY/M/D HH:mm:ss');
    },
  },
  mounted() {},
  methods: {
    print() {
      this.$refs[this.formStructure.key].validate((valid) => {
        if (valid) {
          this.createReport({
            reportKey: 'accountBalance',
            delegateData: this.model
          });
          this.readonly = true;
        } else {
          this.$notify({
            title: this.$qt('notify.exceptionTitle'),
            message: this.$qt('validation.completeFormMessage'),
            type: 'error'
          });
          return false;
        }
      });
    }
  },
};

// $(document).ready(function() {
//   //        Paths Web Service
//   $.post("getPath.do", function(data) {
//     var path = null;
//     var result = JSON.parse(data);
//     result.forEach(function(option) {
//       $("#paths").append(
//         "<option " + 'value="' + option.id + '">' + option.caption + "</option>"
//       );
//     });

//     $("#paths").selectpicker();
//   });

//   $(".report").submit(function(e) {
//     e.preventDefault();
//     var $inputs = $("#report-form :input");
//     var values = "?";
//     $inputs.each(function() {
//       if (this.name != "") {
//         values += this.name + "=" + $(this).val();
//         values += "&";
//       }
//     });

//     values = values.slice(0, -1);

//     console.log(values);
//     window.open(
//       "wayBillReport.do" + values,
//       "reportWindow",
//       "_blank",
//       "toolbar=0,location=0,menubar=0,height=900,width=600"
//     );
//   });
// });
</script>

<style scoped></style>
